import styled from 'styled-components';
import { darken } from 'polished';
import DatePicker from 'react-datepicker';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  height: 100%;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Selects = styled.div`
  display: flex;
`;

export const Select = styled.div`
  width: 250px;
  margin-right: 10px;
`;

export const Wrapper = styled.div`
  display: flex;

  @media (max-width: 1200px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const Filtro = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
`;

export const Button = styled.button`
  background: #626ed4;
  height: 40px;
  width: ${props => (props.reset ? '80px' : '60px')};
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  & + button {
    margin-left: 10px;
  }

  margin-right: ${props => props.reset && '10px'};
`;

export const DS = styled(DatePicker)`
  width: 150px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 4px;
  color: #dee2e6;
  background: #323a4e;
  padding: 10px 5px;
  margin: 20px 5px;
`;
